import EmptyView1 from '../../layouts/EmptyView1'
import ContactUs from './ContactUs'

export default EmptyView1(ContactUs)



// WEBPACK FOOTER //
// ./src/pages/contact-us/index.js